function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgAgroEIndustria = function SvgAgroEIndustria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.997 8.507l.302-1.712a2.001 2.001 0 00-1.622-2.317l-7.06-1.245A1.999 1.999 0 002.3 4.856l-1.245 7.06a2.05 2.05 0 00-.02.137 4.625 4.625 0 108.171 4.204h6.046a3.125 3.125 0 006.245-.003 2 2 0 001.835-2.43l-.833-3.75a2 2 0 00-1.953-1.567h-2.046V6.758a1 1 0 011-1h.75v-1h-.75a2 2 0 00-2 2v1.75h-4.504zM3.285 5.03l-1.02 5.785a4.625 4.625 0 017.194 4.443h5.916a3.126 3.126 0 016.002 0h.004a1 1 0 00.976-1.217l-.833-3.75a1 1 0 00-.977-.783h-8.742l.104-.587.406-2.298a1.001 1.001 0 00-.812-1.16l-7.06-1.244a.999.999 0 00-1.158.811zm15.09 13.228a2.124 2.124 0 10.002-4.249 2.124 2.124 0 00-.001 4.25zm-13.5 0a3.625 3.625 0 10.002-7.249 3.625 3.625 0 00-.001 7.25zm1.126-3.625a1.125 1.125 0 10-2.25 0 1.125 1.125 0 002.25 0z",
    fill: props.color
  }));
};
SvgAgroEIndustria.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgAgroEIndustria.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgAgroEIndustria;